import { SelectionGroup,SelectionItem } from "../Selection/Selection";
import { setPropertyType } from "../../ReduxSlices/SearchSlice";
export const PropertyTypeFilter = ({ propertyType, dispatch }) => {
    const propertyTypes = ['House', 'Apartment', 'Guesthouse', 'Hotel'];
    
    return (
      <div>
        <div className="text-[16px] sm:text-[18px] font-semibold">Property type</div>
        <SelectionGroup
          defaultItem={propertyType}
          className="flex gap-[6px] sm:gap-[8px] text-[#D5D5D5] my-[10px] sm:my-[12px] flex-wrap"
        >
          {propertyTypes.map((type, index) => (
            <SelectionItem
              key={type}
              SelectedItem={
                <div className="bg-[#F6F6F6] min-w-[80px] sm:min-w-[100px] hover:bg-[#ffffff] w-full py-[20px] sm:py-[30px] border-[1px] rounded-[12px] sm:rounded-[16px] text-center border-[#5B1DEE] text-[#5B1DEE] text-[12px] sm:text-sm">
                  {type}
                </div>
              }
              UnselectedItem={
                <div
                  className="bg-[#F6F6F6] min-w-[80px] sm:min-w-[100px] hover:bg-[#ffffff] w-full py-[20px] sm:py-[30px] border-[1px] rounded-[12px] sm:rounded-[16px] text-center text-[12px] sm:text-sm"
                  onClick={() => dispatch(setPropertyType(index))}
                >
                  {type}
                </div>
              }
            />
          ))}
        </SelectionGroup>
      </div>
    );
  };
  